import { Cookies, getCookie, setCookie } from '@deporvillage/utils-library-component';

const Styles = {
    '#app-HeaderApp, #app-FooterApp, [class*=footer-mobile-component], [class*=header-mobile-component]': 'display: none!important',
    '.footer-component.mobile': 'padding-bottom: 2.5rem',
    '[class*="ad-block-wrapper"]': 'margin-top: 20px!important',
    '[class*="header-wrapper"], [class*="footer-mobile-component"], [class*="footer-desktop-component"]': 'display: none!important',
    '[class*="LoginPopup-module-form-input"]:last-of-type': 'display: none!important',
    '[class*="responsive-banner"][class*="promo-banner"] > div': 'margin-top: 1rem!important; height: 0!important;',
    '#onetrust-pc-sdk, #onetrust-banner-sdk': 'display: none!important; height: 0!important; visibility: hidden!important;',
    '[class*="ads-promo-wrapper"], [class*="breadcrumb-component"], [class*="paypal-static-component"] [class*="message"] a, [class*="paypal-dynamic-component"]': 'display: none!important',
    '[class*="paypal-static-component"]': 'margin-top: 25px',
    '[class*="paypal-widget-component"]': 'margin-top: -25px',
    '[class*="form-input"] [class*="social-login-or"], [class*="form-input"] [class*="google-social-button"], [class*="register-component"] [class*="social-register-wrapper"], [class*="register-component"] [class*="form-component"] [class*="title-form"]': 'display: none!important',
    '[class*="social-login-wrapper"]': 'background: none!important',
    '[class*="social-login-wrapper"] [class*="title-social"], [class*="social-login-wrapper"] [class*="social-login"]': 'display: none!important',
    '.main-container-checkout-footer, [class*="social-login-or"], [class*="checkout-header"],[class*="google-social-button"], [class*="social-register-wrapper"], [class*="register-component"] [class*="form-component"] [class*="title-form"]': 'display: none!important',
    '[class*="checkout-contact-footer"]': 'margin-bottom: 50px!important',
    '[class*="checkout-stepper-wrapper"]': 'margin-top: -2rem!important',
    '[class*="checkout-page-component"]': 'padding-bottom: 4rem!important',
};

const getParam = (param) => window.location.href.indexOf(`${param}=`) !== -1;

const generateStyle = (head, style, value) => {
    // eslint-disable-next-line no-param-reassign
    style.innerHTML += value;
    head.appendChild(style);
};

const handleInit = () => {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    Object.keys(Styles).map((k) => generateStyle(head, style, `${k} { ${Styles[k]} }`));
};

const isInApp = () => {
    if (getCookie(Cookies.InApp) || getParam('customapp')) {
        setCookie(Cookies.InApp, 1, 365);
        handleInit();
    }
};

export default isInApp;
